var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('h2',[_vm._v(" "+_vm._s(_vm.__('messages.know_destinations'))+" "+_vm._s(_vm.country.name))]),_vm._v(" "),_c('CountryDestinationGroup',{attrs:{"groups":_vm.groups}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }